import React, { FC, ReactNode } from 'react'
import { Grid, GridProps } from '@mui/material'

interface GridRowProps extends GridProps {
  children?: ReactNode
}

export const GridRow: FC<GridRowProps> = ({ children, spacing = 0, ...props }) => {
  return (
    <Grid container spacing={spacing} {...props}>
      {children}
    </Grid>
  )
}
